import { apiClient } from "@apis/apiClient";
import {
  CellTowerAnalysisResponse,
  CellTowerConfidenceLevel,
  CleanupResponse,
} from "./wifiCellularMismatchClient.dto";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  getById(id: any) {
    return apiClient.get("/rest/wifi_cellular_mismatch/" + id);
  },

  getByIds(params: any) {
    return apiClient.post(
      `/rest/wifi_cellular_mismatch/byIds`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  delete(id: any, deleteAll: any = false, addToPrivate: any = false) {
    return apiClient.delete(`/rest/wifi_cellular_mismatch/${id}`, {
      params: {
        deleteAll: deleteAll,
        addToPrivate: addToPrivate,
      },
    });
  },

  createPrivateCellularTower(id: any, location: any) {
    return apiClient.post(
      `/rest/wifi_cellular_mismatch/private_cell_towers/${id}`,
      location
    );
  },

  deletePrivateCellularTower(id: any) {
    return apiClient.delete(
      `/rest/wifi_cellular_mismatch/private_cell_towers/${id}`
    );
  },

  analyzeCellTowers() {
    return apiClient.get<CellTowerAnalysisResponse>(
      "/rest/wifi_cellular_mismatch/analysis"
    );
  },

  cleanupHarvestedMismatches(minConfidence: CellTowerConfidenceLevel = "MEDIUM") {
    return apiClient.delete<CleanupResponse>(
      `/rest/wifi_cellular_mismatch/cleanup/harvested?minConfidence=${minConfidence}`
    );
  },
};
